const getState = (state) => state.app;
export const getAppState = (state) => getState(state);
export const getFormState = (state) => getState(state).form;
export const getCMSState = (state) => getState(state).cms;
export const getAvailability = (state) => getState(state).availability;
export const getArticlesToShow = (state) => getState(state).articlesToShow;
export const getFormStorageTypeTagState = (state) => getState(state).form.tagState.storage_type;
export const getFormStorageTypeState = (state) => getState(state).form.storage_type;
export const getIsBVersion = (feature) => (state) => getState(state).ab_tests.includes(feature);
export const getCartState = (state) => getState(state).cart;
export const getSorting = (state) => getState(state).sorting;
//# sourceMappingURL=selectors.js.map